// extracted by mini-css-extract-plugin
export default {"row":"terminal_row__es4yd","col":"terminal_col__C0I8V","card":"terminal_card__ple9P"};